import React from 'react';
import PrivateRoute from '../../routes/privateRoute';

const Scan = React.lazy(() => import('./views/Scan'));

const scanRoutes = {
    path: '/scan',
    name: 'Scan & Upload',
    component: Scan,
    icon: 'dripicons-camera',
    route: PrivateRoute,
    children: [{}],
    permissions: [{name: ['Scan.FullControl']}],
};

export default scanRoutes;
